<template>
  <DragPanel
    title="属性"
    :closePanel="closePanel"
    class="common-drag-panel">
    <div
      class="attr-list-box"
      v-if="vectorAttrData.length">
      <div
        v-for="(item, index) in vectorAttrData"
        :key="index"
        class="item-box">
        <div class="label-box">{{ item.key }}</div>
        <div class="value-box">{{ item.value }}</div>
      </div>
    </div>
    <div class="content-empty" v-else>
      <bj-empty
        :image="require('@/assets/img/no-data.png')"
        class="empty-page">
        <template slot="description"
          ><span class="empty-text">当前构件没有属性信息</span></template
        >
      </bj-empty>
    </div>
  </DragPanel>
</template>

<script>
import DragPanel from '@/components/CustomDragPanel.vue'

export default {
  data() {
    return {}
  },
  props: {
    vectorAttrData: Array,
    closePanel: Function
  },
  components: {
    DragPanel
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.common-drag-panel {
  top: 150px;
  right: 20px;
  width: 360px;
  min-width: 360px;
  height: calc(100% - 225px);
  min-height: calc(100% - 225px);

  :deep(.content) {
    height: calc(100% - 40px);

    .attr-list-box {
      margin: 8px 16px;
      max-height: 100%;
      font-size: 12px;
      overflow-y: auto;
      border: 1px solid var(--attr-border-color);

      .item-box {
        display: grid;
        grid-template-columns: 1fr 2fr;
        text-align: left;
        border-bottom: 1px solid var(--attr-border-color);

        &:last-child {
          border-bottom: none;
        }

        .label-box {
          word-break: break-all;
          padding: 4px 0px 4px 24px;
          color: var(--collapse-text-label-color);
          border-right: 1px solid var(--attr-border-color);
        }

        .value-box {
          word-break: break-all;
          padding: 4px 4px 4px 8px;
          color: var(--collapse-text-value-color);
        }
      }
    }
  }
}

.content-empty{
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
